import React, { PureComponent } from 'react';
import { ModalProvider } from 'styled-react-modal';
import styled from 'styled-components';
import { CloseButton, Button } from '../styled-components/';
import { Container, StickyHeader } from '../styled-components/Layout';
import localize from '../util/localizeUtils';
import { Modal, ModalOverlay, ModalHeader } from '../styled-components/Modal';

const ComponentContainer = styled.div`
  display: inline-block;
`;

const LicenseBody = styled.div`
margin: 0;
max-height: 50vh;
overflow: auto;
padding: 0 .5rem .5rem .5rem;
background: ${props => props.theme.modal.background};
`;

class LicenseDialog extends PureComponent {
  constructor() {
    super();

    this.state = {
      open: false
    };
  }
/* eslint-disable */
  render() {
    return (
      <ComponentContainer>
        <Button type="button" onClick={() => this.setState({ open: true })}>{localize('licenseAgreementButton')}</Button>
        <ModalProvider>
          <Modal
            isOpen={this.state.open}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={() => this.setState({ open: false })}
            contentLabel="LicenseModal"
          >
            <Container>
              <ModalHeader>
                <span>{localize('licenseDialogTitle')}</span>
                <CloseButton onClick={() => this.setState({ open: false })}>&times;</CloseButton>
              </ModalHeader>
              <LicenseBody>
                <div id="licenseAgreement">
                  <p align="center">
                    <strong />
                  </p>
                  <p align="center">
                    <strong>CHYRONHEGO SOFTWARE LICENSE AGREEMENT</strong>
                  </p>
                  <p>
                      THIS SOFTWARE LICENSE AGREEMENT (the "Agreement") is being entered into as of the date of purchase. The parties to this Agreement are ChyronHego
                      Corporation, a New York Corporation ("ChyronHego"), and the registered user, "Licensee". This Agreement is a legal agreement between Licensee and
                      ChyronHego for the software identified on the packing list, which includes computer software and associated media and printed materials (if any)
                      (collectively, the "Software"). BY INSTALLING, COPYING (AS PERMITTED BY THE TERMS OF THIS AGREEMENT) OR OTHERWISE USING THE SOFTWARE (INCLUDING USE OF A
                      CHYRONHEGO PRODUCT ON WHICH THE SOFTWARE IS PRE-INSTALLED BY OR ON BEHALF OF CHYRONHEGO), LICENSEE AGREES TO BE BOUND BY THE TERMS OF THIS AGREEMENT. IF,
                      PRIOR TO DOWNLOADING, INSTALLING, ACTIVATING, OR USING THE SOFTWARE, LICENSEE DOES NOT AGREE TO THE TERMS OF THIS AGREEMENT, LICENSEE IS NOT AUTHORIZED TO
                      USE THE SOFTWARE. The Software is protected by copyright laws and international copyright treaties, as well as other intellectual property laws and
                      treaties.
                  </p>
                  <p>
                      1. <strong>Definitions</strong>. Unless the context requires otherwise, the defined terms in this Agreement shall have the meanings set out below
                      (including the plural, and vice versa).
                  </p>
                  <p>
                      “ChyronHego Product” means any hardware manufactured by or on behalf of ChyronHego.
                  </p>
                  <p>
                      “Documentation” means the applicable installation guide or standard end user documentation prepared and supplied by ChyronHego for the ChyronHego Product
                      and Software.
                  </p>
                  <p>
                      “Software” means any of the ChyronHego proprietary software (comprised of ChyronHego proprietary software, interfaces, content and data) provided to
                      Licensee under this Agreement, a single copy of which is designed to be accessed by the ChyronHego Product at any one time. The term “Software” shall not
                      include any Third Party Software, whether or not the Third Party Software accompanies, is provided with, or operates in conjunction with the Software
                      and/or any ChyronHego Product.
                  </p>
                  <p>
                      “Third Party Software” means software applications that are not proprietary to ChyronHego and that originate with a third party.
                  </p>
                  <p>
                    <strong> 2. License</strong>
                      .
                  </p>
                  <p>
                      (a) <strong>Grant of License</strong>.
                  </p>
                  <p>
                      Subject to the terms and conditions contained herein, ChyronHego grants to the Licensee and Licensee accepts from ChyronHego a non-exclusive, revocable,
                      non-transferable, worldwide license to use the Software. Licensee acknowledges that no right to download, upload, use, print, copy or display the Software,
                      in whole or in part, is granted hereby except as expressly provided in this Agreement. Licensee may not use or allow the use of the Software other than for
                      Licensee’s own business purposes and other than as part of a ChyronHego Product. This Agreement does not imply any rights to (i) future upgrades or updates
                      of the Software or Third Party Software; (ii) acquire new or modified ChyronHego Products or other services; or (iii) use Third Party Software in a manner
                      exceeding that freely permitted by such Third Party.
                  </p>
                  <p>
                      (b) <strong>Permitted Uses and Restrictions</strong>.
                  </p>
                  <p>
                      This License allows Licensee to use the Software on a single computer at a time, and to make one copy of the Software in machine-readable form for backup
                      purposes only. The backup copy must include all copyright information contained in the original. Licensee may transfer the Software on a permanent basis to
                      another person or entity, provided that
                  </p>
                  <p>
                      (i) Licensee gives prior written notice of such transfer to ChyronHego,
                  </p>
                  <p>
                      (ii) Licensee retains no copies of the Software, and
                  </p>
                  <p>
                      (iii) the transferee agrees in writing to be bound by the terms of this Agreement.
                  </p>
                  <p>
                      Licensee may not:
                  </p>
                  <p>
                      (i) distribute copies of the Software in whole or in part,
                  </p>
                  <p>
                      (ii) reverse engineer, decompile, disassemble, modify or translate the Software or make any attempt to discover the source code of the Software or create
                      derivative works from the Software in any manner whatsoever, except to the extent that ChyronHego is expressly precluded by law from prohibiting these
                      activities,
                  </p>
                  <p>
                      (iii) rent or lease the Software, or
                  </p>
                  <p>
                      (iv) use a previous version or copy of the Software after Licensee has received an upgraded version of the Software as a replacement of the prior version.
                  </p>
                  <p>
                      Licensee will cooperate with ChyronHego and provide information requested by ChyronHego to assist ChyronHego in investigating or determining whether there
                      has been a breach of this Agreement and provide ChyronHego with access to the premises where the ChyronHego Products and Software have been used.
                  </p>
                  <p>
                      (c) <strong>Third Party Software</strong>. The ChyronHego Product may include Third Party Software when originally shipped by ChyronHego. The use of the
                      Third Party Software (including any updates or upgrades thereto may be subject to separate or additional terms and conditions, including any applicable use
                      restrictions, license agreement, warranties and/or disclaimers. These separate or additional terms and conditions, if any, will be made available in a text
                      file accompanying the Software, or in the case of Third Party Software that is pre-installed by ChyronHego with the ChyronHego Product before shipment,
                      will be made available with the packing list for the ChyronHego Product. With respect to Third Party Software provided to Licensee, ChyronHego is only able
                      to provide such software with Licensee’s acknowledgement and agreement that such software is: (a) provided as a convenience to Licensee only; and (b)
                      unless it is accompanied by a separate software license, is subject to the terms and conditions of this Agreement as it were Software. If Licensee does not
                      agree to these terms, Third Party Software should be obtained directly from its suppliers. If a separate license agreement or additional terms and
                      conditions apply to any Third Party Software provided by ChyronHego, then the provisions of this Agreement related to Third Party Software will still apply
                      and in no event shall such separate license agreements or additional terms and conditions between Licensee and the supplier be binding on ChyronHego or
                      impose any additional obligations, or obligations inconsistent with the terms of this Agreement, upon ChyronHego whatsoever.
                  </p>
                  <p>
                      (d) <strong>Ownership</strong>.
                  </p>
                  <p>
                      By virtue of this Agreement, Licensee acquires only the right to use the Software and does not obtain any rights of ownership, including patents, designs,
                      trademarks, copyright, or rights in any confidential information or trade secrets in or relating to the ChyronHego Product or any part thereof. All right,
                      title, and interest in and to the Software and in all patent, copyright, trademark, and other proprietary rights therein shall remain the sole property of
                      ChyronHego. Any rights not expressly granted herein are expressly reserved.
                  </p>
                  <p>
                      3. <strong>Licensee's Responsibilities</strong>.
                  </p>
                  <p>
                      Licensee shall be exclusively responsible for the supervision, management and control of its use of the Software, and it will:
                  </p>
                  <p>
                      (i) hold the Software in strict confidence;
                  </p>
                  <p>
                      (ii) limit access to the Software to only those who need access with respect to Licensee's use of the Software in connection with Licensee's business; and
                  </p>
                  <p>
                      (iii) implement procedures sufficient to satisfy its obligations for security under this Agreement (which shall include appropriate action between it and
                      its employees to prevent misuse, unauthorized copying, modification, or disclosure).
                  </p>
                  <p>
                      4. (a) <strong>No Warranty</strong>.
                  </p>
                  <p>
                      Any use of the Software is at Licensee's own risk. The Software is provided "AS IS." To the maximum extent permitted by applicable law, ChyronHego and its
                      suppliers disclaim all warranties and conditions, either express or implied, including, but not limited to, implied warranties of merchantability, fitness
                      for a particular purpose, and noninfringement. ChyronHego does not warrant that the functions contained in the Software will meet Licensee's requirements
                      that the operation of the Software will be uninterrupted or error-free, or that defects in the Software will be corrected. In addition, no oral or written
                      information or advice given by ChyronHego shall create a warranty or in any way increase the scope of this warranty. CHYRONHEGO MAKES AND LICENSEE RECEIVES
                      NO WARRANTY EXPRESS OR IMPLIED AND THERE ARE EXPRESSLY EXCLUDED ALL WARRANTIES OF MERCHANTABILITY, SATISFACTORY QUALITY, FITNESS FOR A PARTICULAR PURPOSE,
                      NONINFRINGEMENT OF THIRD PARTY RIGHTS OR TITLE, OR ARISING FROM A STATUTE OR CUSTOM OR A COURSE OF DEALING OR USAGE OF TRADE.
                  </p>
                  <p>
                      THE PARTIES ALSO AGREE THAT THE UNIFORM COMPUTER TRANSACTIONS ACT (“UCITA”) AS ENACTED IN ANY STATE SHALL NOT APPLY TO THIS AGREEMENT AND TO THE MAXIMUM
                      EXTENT PERMITTED BY LAW, UCITA IS HEREBY EXCLUDED IN ITS ENTIRETY FROM APPLICATION TO THIS AGREEMENT.
                  </p>
                  <p>
                      ALL THIRD PARTY SOFTWARE IS PROVIDED OR MADE ACCESSIBLE BY CHYRONHEGO “AS IS” AND “AS AVAILABLE” AND CHYRONHEGO SHALL HAVE NO LIABILITY WHATSOEVER TO
                      LICENSEE OR TO ANY THIRD PARTY CLAIMANT BY OR THROUGH LICENSEE, FOR ANY ISSUE RELATING TO THE THIRD PARTY SOFTWARE, INCLUDING WITHOUT LIMITATION THE
                      PERFORMANCE OR NON-PERFORMANCE OF THE THIRD PARTY SOFTWARE, THE INTEROPERABILITY OF THE THIRD PARTY SOFTWARE WITH ALL OR A PORTION OF THE SOFTWARE OR THE
                      CHYRONHEGO PRODUCT OR USE OF THE THIRD PARTY SOFTWARE BEYOND OR IN EXCESS OF THAT WHICH IS PERMITTED BY THE THIRD PARTY SOFTWARE TERMS AND CONDITIONS. YOU
                      SPECIFICALLY AGREE THAT CHYRONHEGO IS NOT RESPONSIBLE OR LIABLE FOR ANY VIRUSES OR FOR THIRD PARTY SOFTWARE THAT INFRINGES ANY INTELLECTUAL PROPERTY RIGHTS
                      OF OTHERS. LICENSEE’S RECOURSE IN THE EVENT OF ANY SUCH CLAIM WITH RESPECT TO ANY THIRD PARTY SOFTWARE SHALL BE SOLELY AGAINST THE RELEVANT THIRD PARTIES
                      AND SHALL SPECIFICALLY EXCLUDE CHYRONHEGO. LICENSEE AGREES THAT UNDER NO CIRCUMSTANCES SHALL INDEMNIFICATION BE SOUGHT FROM CHYRONHEGO AS A RESULT OF
                      LICENSEE’S USE OF THIRD PARTY SOFTWARE, NOR SHALL CHYRONHEG BE SOUGHT TO BE LIABLE THEREFOR.
                  </p>
                  <p>
                      (b) <strong>No Consequential Damages</strong>.
                  </p>
                  <p>
                      To the maximum extent permitted by applicable law, in no event shall ChyronHego or its suppliers be liable for any special, incidental, indirect, or
                      consequential damages whatsoever (including, without limitation, damages for loss of business profits, business interruption, loss of business information,
                      or any other pecuniary loss) arising out of the use of or inability to use the Software, even if ChyronHego has been advised of the possibility of such
                      damages. CHYRONHEGO SHALL HAVE NO LIABILITY WITH RESPECT TO ITS OBLIGATIONS UNDER THIS AGREEMENT FOR CONSEQUENTIAL, EXEMPLARY OR INCIDENTAL DAMAGES EVEN IF
                      IT HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                  </p>
                  <p>
                      (c) <strong>Limitation of Liability</strong>.
                  </p>
                  <p>
                      ChyronHego's entire liability and Licensee's exclusive remedy under this Agreement shall not exceed two dollars (US $2.00). The limitations, exclusions and
                      disclaimers in this Agreement shall apply:
                  </p>
                  <p>
                      (i) irrespective of the nature of the cause of action, demand, or action by Licensee including but not limited to breach of contract, negligence, tort,
                      strict liability, or any other legal theory and shall survive a fundamental breach or breaches or the failure of the essential purpose of this Agreement or
                      of any remedy contained herein; and
                  </p>
                  <p>
                      (ii) to Chyron, its successors, assigns, agents, suppliers, authorized distributors, and their respective directors, employees and independent contractors.
                  </p>
                  <p>
                      In addition to the limitations and exclusions set forth in this Section, in no event shall any director, employee, agent, distributor, supplier,
                      independent contractor of ChyronHego or any affiliates of ChyronHego have any liability arising from or related to this Agreement.
                  </p>
                  <p>
                      5. <strong>Term and Termination</strong>.
                  </p>
                  <p>
                      This Agreement shall continue in effect until there is a breach by the Licensee of this Agreement or any other agreement related to the purchase or lease
                      of the Software or product using the Software. In the event of such breach by the Licensee this Agreement shall immediately terminate. Upon termination of
                      this Agreement, Licensee shall promptly turn over to ChyronHego the Software and all disks, tapes, printed material, drawings, notes, memoranda, or other
                      tangible embodiments relating thereto (collectively, the "Materials"). In the alternative, ChyronHego may consent to the Licensee's destruction of the
                      Materials. The Licensee shall provide to ChyronHego, within five (5) days of the termination date, a written certification from the Licensee certifying
                      that it has either destroyed or returned the Materials.
                  </p>
                  <p>
                      6. <strong>Miscellaneous.</strong>
                  </p>
                  <p>
                      (a) <strong>Entire Agreement</strong>.
                  </p>
                  <p>
                      This Agreement constitutes the complete and exclusive statement of the agreement between the parties hereto, which supersedes and merges all prior
                      proposals, understandings, and all other agreements, oral and written, between the parties relating to this Agreement. This Agreement may not be modified
                      or altered except by written instrument duly executed by both parties. No terms of any purchase order presented by Licensee shall take precedence over the
                      terms and conditions of this Agreement. If there is any inconsistency between this Agreement and the Terms and Conditions of Sale provided with the
                      ChyronHego Product, the provisions of this Agreement shall apply to the extent of the inconsistency.
                  </p>
                  <p>
                      (b) <strong>Export Restrictions and U.S. Government Licenses</strong>. Licensee acknowledges that the Software includes encryption software that may be
                      subject to export, import and/or use controls by Government Authorities (as hereinafter defined) by way or law or regulation. Licensee agrees that the
                      ChyronHego Product and Software will not be exported, imported, used, transferred, or re-exported except in compliance with the laws and regulations of the
                      national and/or other government authorities with authority over the country(ies) and/or territory(ies) from which the ChyronHego Product and Software are
                      being exported or to which the ChyronHego Product and Software are being imported (collectively, the “Government Authority(ies)”). Without limitation, the
                      ChyronHego Product and Software will not be exported: (i) to any country subject to U.S. or U.N. economic sanctions and embargoes; and (ii) to persons or
                      entities prohibited from receiving U.S. exports or U.S.-origin items. Licensee hereby represents that: (1) to the best of its knowledge, it is eligible to
                      receive the ChyronHego Product and Software under applicable law; (2) Licensee will not use the ChyronHego Product and Software in the development,
                      production, handling, storage, or otherwise of chemical, biological, or nuclear weapons, or their missile delivery systems, or of materials or equipment
                      that could be used in such weapons or their missile delivery systems, or resell or export to anyone or any entity involved in such activity; and (3)
                      Licensee will ensure that the ChyronHego Product and Software are used in accordance with the foregoing restrictions. Licensee hereby agrees to indemnify
                      ChyronHego from any claims, actions, liability or expenses (including reasonable attorneys’ fees) resulting from Licensee’s failure to act in accordance
                      with the acknowledgements, agreements and representations in this Section. Notwithstanding any agreement with a third party or any provision of law,
                      regulation or policy, if Licensee is any agency of the government of the United States of America, then Licensee’s rights in respect of the Software shall
                      not exceed the rights provided under this Agreement, unless expressly agreed upon by ChyronHego in a written agreement between Licensee and ChyronHego.
                  </p>
                  <p>
                    <strong> (c) Choice of Law and Dispute Resolution</strong>
                      .
                  </p>
                  <p>
                      This Agreement and the performance hereunder shall be governed by the laws of the State of New York, excluding any body of law governing conflicts of law.
                      The parties agree that the United Nations Convention on Contracts for the International Sale of Goods is hereby excluded in its entirety from application
                      to this Agreement. Licensee hereby irrevocably waives any objection on the grounds of venue, forum non-conveniens or any similar grounds and irrevocably
                      consents to the jurisdiction of the federal or state courts located in the State of New York for any claims arising from or related to this Agreement. The
                      parties specifically agree that, in the event that there is a dispute under this Agreement and such dispute is to be resolved in a court of law, such
                      dispute shall not be resolved by jury trial. The parties hereby waive all rights to a trial by jury in any matter related to or arising from this
                      Agreement.
                  </p>
                  <p>
                      (d) <strong>Limitation on Actions</strong>.
                  </p>
                  <p>
                      No action, regardless of form, arising out of this Agreement may be brought by Licensee more than two years after the cause of action has arisen.
                  </p>
                  <p>
                      (e) <strong>Equitable Relief</strong>.
                  </p>
                  <p>
                      Licensee hereby acknowledges that unauthorized disclosure or use of the Software will cause irreparable harm and significant injury to ChyronHego that may
                      be difficult to ascertain. Accordingly, Licensee agrees that ChyronHego will have the right to obtain immediate injunctive relief to enforce obligations
                      under this Agreement in addition to any other rights and remedies it may have.
                  </p>
                  <p>
                      (f) <strong>Severability</strong>.
                  </p>
                  <p>
                      If any provision of this Agreement is invalid under any applicable statute or rule of law, it is to that extent to be deemed omitted.
                  </p>
                  <p>
                      (g) <strong>Non-Assignability</strong>.
                  </p>
                  <p>
                      The Licensee may not assign or sub-license, without the prior written consent of ChyronHego, its rights, duties or obligations under this Agreement to any
                      person or entity.
                  </p>
                  <p>
                      (h) <strong>Expenses</strong>.
                  </p>
                  <p>
                      ChyronHego shall have the right to collect from Licensee its reasonable expenses incurred in enforcing this Agreement including reasonable attorney's fees.
                  </p>
                  <p>
                      (i) <strong>Waiver</strong>.
                  </p>
                  <p>
                      The waiver or failure of any party to exercise in any respect any right provided for herein shall not be deemed a waiver of any further right hereunder.
                  </p>
                  <p>
                      (j) <strong>Language</strong>.
                  </p>
                  <p>
                      If this Agreement is translated into a language other than English, the English version will prevail to the extent that there is any conflict or
                      discrepancy in meaning between the English version and any translation thereof.
                  </p>
                  <p>
                      Notices, terms and conditions pertaining to third party software are located at one of these two URLs
                  </p>
                  <p>
                    <a href="http://www.chyron.com/support/downloads/cat_view/357-ChyronHego-third-party-legal-notices" target="_blank">
                          http://www.Chyron.com/support/downloads/cat_view/357-ChyronHego-third-party-legal-notices
                      </a>
                  </p>
                  <p>
                    <a href="http://www.ChyronHego.com/third-party-legal-notices" target="_blank">
                        http://www.ChyronHego.com/third-party-legal-notices
                    </a>
                  </p>
                  <p>
                      and incorporated by reference herein.
                  </p>
                </div>
              </LicenseBody>
            </Container>
          </Modal>
        </ModalProvider>
      </ComponentContainer>
    );
  }
  /* eslint-enable */
}

export default LicenseDialog;



// WEBPACK FOOTER //
// ./app/components/LicenseDialog.js